import { normalizeCountryName } from '@/utils/normalizeCountryName';
import { type ClinicianTrialRecapTestimonialVariant } from '@heidi/commerce';
import { Region } from '@heidi/schema/ml-scribe';

export function resolveClinicianTrialRecapTestimonialVariant(
  region: Region,
  country: string | null | undefined
): ClinicianTrialRecapTestimonialVariant {
  const normalizedCountry = normalizeCountryName(country);
  if (normalizedCountry === 'New Zealand') return 'nz';
  if (region === Region.US || region === Region.US_AZ1) return 'us';
  if (region === Region.CA) return 'ca';
  return 'au';
}
